"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const eqMainTheme_1 = require("../../../themes/eqMainTheme");
const column = (theme) => ({
    color: 'grey.600',
    fontSize: 12,
    fontFamily: eqMainTheme_1.fonts.Black,
    letterSpacing: '2.6px',
    fontWeight: '900',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    marginY: eqMainTheme_1.Spacings.small3,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        marginTop: eqMainTheme_1.Spacings.medium,
    },
});
const item = {
    color: 'grey.100',
    fontSize: 14,
    marginTop: { xs: eqMainTheme_1.Spacings.small3, sm: eqMainTheme_1.Spacings.small2 },
    marginBottom: { xs: eqMainTheme_1.Spacings.small3, sm: 0 },
    lineHeight: '1.43',
    textAlign: { xs: 'center', sm: 'left' },
};
const link = {
    color: 'grey.100',
};
exports.default = {
    column,
    item,
    link,
};
